<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <img class="mr-2" :src="require(`@/assets/appIcon-apps--SignupForms.svg`)" width="18">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'FormList'}" class="subtitle-1 routerLink font-weight-medium">Signup Forms</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>

            <v-skeleton-loader class="mt-2 d-inline-block" v-if="$store.state.apps.retrieveLoader" type="text" width="200" />
            <v-text-field class="d-inline-block" v-else v-model="$v.editable.name.$model" :error="$v.editable.name.$error" maxlength="56" outlined single-line dense background-color="white" hide-details>
              <template v-slot:append>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon class="mr-2 mt-0" v-on="on" size="20" color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Un nombre único e interno que te ayude a identificar el formulario dentro de tu organización.</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background" style="height: calc(100vh - 225px); overflow-y: auto;">
          <v-row class="fill-height">
            <v-col cols="4" class="fill-height overflow-y-auto">
              <v-skeleton-loader class="transparent" v-if="$store.state.apps.retrieveLoader" type="list-item-three-line, list-item-three-line" />

              <template v-else>
                <!-- step 1 -->
                <template v-if="step === 1">
                  <!-- plans -->
                  <v-list class="transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Productos</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title :class="{ 'red--text': $v.editable.available_plans.$error && !$v.editable.available_plans.$each.$error }">Planes</v-list-item-title>
                      <v-list-item-subtitle>
                        <product-plan-selector action-justify="end" :key="updateProductDialog" @selected="setPlan" :selected-items="editable.available_plans.map(ap => { return ap.plan.id })" :currency="getCurrency()" />
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-expansion-panels class="mb-6" v-if="editable.available_plans.length">
                    <v-expansion-panel v-for="(p, i) in editable.available_plans" :key="p.id">
                      <v-expansion-panel-header>
                        <v-row justify="space-between" align="center">
                          <span class="body-2" :class="{ 'red--text': $v.editable.available_plans.$each[i].$invalid }">{{p.plan.name}}</span>
                          <v-btn class="mr-6" @click.stop="editable.available_plans.splice(i, 1)" text icon small color="red"><v-icon size="18">mdi-close</v-icon></v-btn>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-divider />
                        <v-list class="transparent mt-4">
                          <v-list-item class="px-0">
                            <v-list-item-title>Nombre</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model="$v.editable.available_plans.$each[i].name.$model" :error="$v.editable.available_plans.$each[i].name.$error" outlined single-line dense background-color="white" hide-details />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Descripción</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model="$v.editable.available_plans.$each[i].description.$model" :error="$v.editable.available_plans.$each[i].description.$error" outlined single-line dense background-color="white" hide-details />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0 py-2">
                            <v-list-item-title>
                              Permitir cantidad
                              <v-tooltip right max-width="280px" transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                </template>
                                <span>Tu cliente podrá asignar la cantidad de unidades de este plan.</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-switch class="mt-n4" v-model="editable.available_plans[i].allow_quantity" style="position: absolute" />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>
                              Cantidad mínima
                              <v-tooltip right max-width="280px" transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                </template>
                                <span>La cantidad mínima permitida de unidades de este plan.</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-col cols="6" class="pa-0">
                                <v-text-field v-model="$v.editable.available_plans.$each[i].min_quantity.$model" :error="$v.editable.available_plans.$each[i].min_quantity.$error" outlined single-line dense background-color="white" hide-details />
                              </v-col>
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>ID personalizado</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model="$v.editable.available_plans.$each[i].custom_id.$model" :error="$v.editable.available_plans.$each[i].custom_id.$error" outlined single-line dense background-color="white" hide-details />
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <!-- addons -->
                  <v-list class="transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title>Complementos</v-list-item-title>
                      <v-list-item-subtitle>
                        <addon-selector action-justify="end" :key="updateAddonDialog" @selected="setAddon" :selected-items="editable.available_addons.map(aa => { return aa.addon.id })" :currency="getCurrency()" />
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>

                  <v-expansion-panels class="mb-6">
                    <v-expansion-panel v-for="(p, i) in editable.available_addons" :key="p.id">
                      <v-expansion-panel-header>
                        <v-row justify="space-between" align="center">
                          <span class="body-2" :class="{ 'red--text': $v.editable.available_addons.$each[i].$invalid }">{{p.addon.name}}</span>
                          <v-btn class="mr-6" @click.stop="editable.available_addons.splice(i, 1)" text icon small color="red"><v-icon size="18">mdi-close</v-icon></v-btn>
                        </v-row>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-divider />
                        <v-list class="transparent mt-4">
                          <v-list-item class="px-0">
                            <v-list-item-title>Nombre</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model="$v.editable.available_addons.$each[i].name.$model" :error="$v.editable.available_addons.$each[i].name.$error" outlined single-line dense background-color="white" hide-details />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Descripción</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-text-field v-model="$v.editable.available_addons.$each[i].description.$model" :error="$v.editable.available_addons.$each[i].description.$error" outlined single-line dense background-color="white" hide-details />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0 py-2">
                            <v-list-item-title>
                              Permitir cantidad
                              <v-tooltip right max-width="280px" transition="scale-transition">
                                <template v-slot:activator="{on}">
                                  <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                </template>
                                <span>Tu cliente podrá asignar la cantidad de unidades de este complemento.</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-switch class="mt-n4" v-model="editable.available_addons[i].allow_quantity" style="position: absolute" />
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>
                              Cantidad mínima
                              <v-tooltip right max-width="280px" transition="scale-transition">
                                <template v-slot:activator="{ on }">
                                  <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                                </template>
                                <span>La cantidad mínima permitida de unidades de este complemento.</span>
                              </v-tooltip>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-col cols="6" class="pa-0">
                                <v-text-field v-model="$v.editable.available_addons.$each[i].min_quantity.$model" :error="$v.editable.available_addons.$each[i].min_quantity.$error" outlined single-line dense background-color="white" hide-details />
                              </v-col>
                            </v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0 py-2">
                            <v-list-item-title>Es obligatorio</v-list-item-title>
                            <v-list-item-subtitle>
                              <v-switch class="mt-n4" v-model="editable.available_addons[i].is_mandatory" style="position: absolute" />
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <!-- end addons -->

                  <!-- another options -->
                  <v-list class="mt-6 px-0 transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Otras opciones</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="px-0 py-2">
                      <v-list-item-title>
                        Permitir la selección de múltiples planes
                        <v-tooltip right max-width="280px" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span>Al activar los clientes podrán suscribirse a múltiples planes.</span>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-action>
                        <v-switch class="mt-n3 ml-n6" v-model="editable.allow_multiple_plans" style="position: absolute" />
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                  <!-- end another options -->
                </template>
                <!-- end step 1 -->

                <!-- step 2 -->
                <template v-else-if="step === 2">
                  <v-list class="transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Facturación</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          Cobertura
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>Los clientes podrán seleccionar solo un país de esta lista.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-select v-model="$v.editable.available_countries.$model" :error="$v.editable.available_countries.$error" :items="baseCountries" item-value="id" item-text="name" label="Selecciona los países" outlined background-color="white" dense multiple single-line hide-details>
                            <template v-slot:prepend-item>
                              <v-list-item ripple @click="toggleCountries">
                                <v-list-item-action>
                                  <v-icon :color="editable.available_countries.length > 0 ? 'indigo darken-4' : ''">{{countriesSelectIcon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Seleccionar todo</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:append-item>
                              <v-divider class="mb-2"></v-divider>
                              <v-list-item disabled>
                                <v-list-item-content v-if="allCountriesSelected || someCountriesSelected">
                                  <v-list-item-title>{{editable.available_countries.length}} países seleccionados</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-content v-else>
                                  <v-list-item-title>Selecciona al menos un país.</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0 pb-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          Tipos de factura
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>Los clientes podrán seleccionar solo un tipo de factura compatible con el país que seleccionen previamente.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-select @change="(value) => availableDocumentAdd(value)" :items="selectDocuments" item-value="id" item-text="name" :item-disabled="availableDocumentIsAdded" label="Selecciona un tipo de factura" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details />
                        </v-list-item-subtitle>
                        <v-alert class="mt-2 mb-0 body-2" text dense border="left" type="error" icon="mdi-alert" v-if="!$v.editable.available_documents.countriesWithoutDocument">
                          Selecciona al menos un tipo de factura compatible con: <template v-for="(c, i) in countriesWithoutDocument">{{c.name}}<template v-if="i < (countriesWithoutDocument.length - 1)">, </template></template>.
                        </v-alert>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-1" v-if="editable.available_documents.length">
                      <v-list-item-content>
                        <v-list-item-title>Moneda de los tipos de factura</v-list-item-title>
                        <v-sheet class="mt-1 overflow-y-auto" outlined rounded>
                          <v-list class="py-0 v-sm-text-fields" dense v-if="editable.available_documents.length">
                            <template v-for="(d, i) in editable.available_documents">
                              <v-list-item class="py-0 my-0" :key="`${i}-item`">
                                <v-list-item-content>
                                  <v-list-item-title>{{availableDocumentName(d.document)}}</v-list-item-title>
                                  <v-list-item-subtitle class="pr-16 font-weight-regular">
                                    <v-select v-model="$v.editable.available_documents.$each[i].currency.$model" :error="$v.editable.available_documents.$each[i].currency.$error" label="Elige una moneda" :items="availableDocumentCurrencies(d.document)" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="26" background-color="white" outlined dense single-line hide-details>
                                      <template v-slot:item="data">
                                        <v-list-item-title class="font-weight-regular">{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                                      </template>
                                    </v-select>
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action class="ma-0 text-right">
                                  <v-btn @click="editable.available_documents.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="18">mdi-delete</v-icon></v-btn>
                                </v-list-item-action>
                              </v-list-item>
                              <v-divider v-if="i < editable.available_documents.length - 1" :key="`${i}-divider`" />
                            </template>
                          </v-list>
                        </v-sheet>
                        <v-row class="mx-0" justify="space-between">
                          <span class="d-block mx-1 py-3 text--secondary body-2">{{editable.available_documents.length}} tipos de comprobante</span>
                          <v-btn class="my-1" @click="editable.available_documents=[]" text color="primary" :ripple="false">Limpiar</v-btn>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-list class="mt-6 transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">
                        Etiquetas personalizadas
                        <v-tooltip right max-width="280px" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span>Personaliza algunas de las etiquetas de los campos del formulario.</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list class="v-list-form v-sm-text-fields" color="transparent">
                      <v-list-item class="px-0" v-for="(d, i) in editable.custom_labels" :key="`custom-label-${d.field_name}`">
                        <v-list-item-title>{{customLabels[d.field_name]}}</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model.trim="$v.editable.custom_labels.$each[i].label.$model" :error="$v.editable.custom_labels.$each[i].label.$error" autocomplete="off" background-color="white" dense hide-details maxlength="24" outlined persistent-hint required single-line />
                        </v-list-item-subtitle>
                      </v-list-item>
                    </v-list>
                  </v-list>
                </template>
                <!-- end step 2 -->

                <!-- step 3 -->
                <template v-else-if="step === 3">
                  <v-list class="transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Pago</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title>
                        Solicitar inscripción de tarjeta
                        <v-tooltip right max-width="280px" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span>Al activar se solicitará a los clientes registrar una tarjeta de crédito / débito.</span>
                        </v-tooltip>
                      </v-list-item-title>
                      <v-list-item-action>
                        <v-switch class="mt-n3 ml-n6" v-model="editable.require_source" style="position: absolute" />
                      </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="py-2 px-0" v-if="editable.require_source">
                      <v-list-item-content>
                        <v-list-item-title class="mb-2">¿Qué se debe hacer primero?</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-radio-group class="my-0" v-model="editable.collection_scheme" hide-details>
                            <v-radio value="charge_payment">
                              <template v-slot:label>
                                <span>Procesar el pago</span>
                                <v-btn class="ml-2" text color="primary" :ripple="false">Ver workflow<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                              </template>
                            </v-radio>
                            <v-radio value="send_invoice">
                              <template v-slot:label>
                                <span>Crear la factura</span>
                                <v-btn class="ml-2" text color="primary" :ripple="false">Ver workflow<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                  <v-list class="mt-6 transparent">
                    <v-list-item class="py-2 px-0">
                      <v-list-item-title class="body-2 text--secondary font-weight-medium">Avanzado</v-list-item-title>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          Redireccionamiento por defecto
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>El cliente será redireccionado a esta url cuando finalice su proceso de suscripción.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model.trim="$v.editable.redirect_url.$model" :error="$v.editable.redirect_url.$error" background-color="white" outlined required single-line dense autocomplete="off" maxlength="64" persistent-hint hide-details placeholder="https://myproduct.com/account/" />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0">
                      <v-list-item-content>
                        <v-list-item-title>
                          Webhook URL
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>Recibe una notificación una vez el registro sea exitoso.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-text-field v-model.trim="$v.editable.webhook_url.$model" :error="$v.editable.webhook_url.$error" background-color="white" outlined required single-line dense autocomplete="off" maxlength="256" persistent-hint hide-details placeholder="https://api.myproduct.com/new_subscription/" />
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0 py-2">
                      <v-list-item-title>
                        Procesamiento instantáneo
                        <v-tooltip right max-width="280px" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span>Al activar, la suscripción se procesará inmediatamente. De lo contrario la suscripción quedará programada para su procesamiento diferido.</span>
                        </v-tooltip>
                        <v-chip class="ml-3" color="primary" text-color="white" small>Beta</v-chip>
                      </v-list-item-title>
                      <v-list-item-action>
                        <v-switch class="mt-n3 ml-n6" v-model="editable.instant" style="position: absolute" />
                      </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="px-0 py-3">
                      <v-list-item-title>
                        Mantener información en caché
                        <v-tooltip right max-width="280px" transition="scale-transition">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                          </template>
                          <span class="text--primary">Al activar, la información del cliente se recordará en su navegador en caso de que este cierre la ventana y quiera continuar el proceso en el futuro.</span>
                        </v-tooltip>
                        <v-chip class="ml-3" color="primary" text-color="white" small>Beta</v-chip>
                      </v-list-item-title>
                      <v-list-item-action>
                        <v-switch class="mt-n3 ml-n6" v-model="editable.use_cache" style="position: absolute" />
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </template>
                <!-- end step 3 -->
              </template>
            </v-col>
            <v-divider vertical />
            <v-col class="fill-height overflow-y-auto">
              <v-skeleton-loader class="transparent" v-if="$store.state.apps.retrieveLoader" type="list-item-three-line, list-item-three-line, list-item-three-line" />
              <form-demo :form-data="editable" :step="step" :currency="currentCurrency" v-else />
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-0 px-4">
          <v-row align="center">
            <v-col cols="4">
              <v-row no-gutters>
                <v-btn v-if="step > 1" @click="step = step - 1" outlined :ripple="false">Atras</v-btn>
                <v-spacer />
                <v-btn v-if="step < 3" @click="step = step + 1" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">Continuar</v-btn>
                <v-btn v-if="step === 3" @click="updateForm" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">Guardar cambios</v-btn>
              </v-row>
            </v-col>
            <v-divider vertical />
            <v-col v-if="step === 3">
              <span class="body-2 red--text" v-if="$v.editable.available_plans.$invalid || $v.editable.available_addons.$invalid"><v-icon color="red" left size="20">mdi-alert</v-icon>Corrige los campos marcados con error en la <v-btn class="mt-n1 text-decoration-underline" @click="step=1" text color="red" :ripple="false">sección de Productos</v-btn></span>
              <span class="body-2 red--text" v-else-if="$v.editable.available_countries.$invalid || $v.editable.available_documents.$invalid"><v-icon color="red" left size="20">mdi-alert</v-icon>Corrige los campos marcados con error en la <v-btn class="mt-n1 text-decoration-underline" @click="step=2" text color="red" :ripple="false">sección de Facturación</v-btn></span>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, minValue, url } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

import GenericViewMixin from '@/mixins/GenericViewMixin'

import AddonSelector from '@/components/subscription/AddonSelector'
import FormDemo from '@/components/signup-forms/FormDemo'
import ProductPlanSelector from '@/components/subscription/ProductPlanSelector'

export default {
  components: {
    AddonSelector,
    FormDemo,
    ProductPlanSelector
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    availableDocumentSelected: null,
    customLabels: {
      name: 'Nombre',
      state: 'Estado',
      tax_id: 'ID Fiscal'
    },
    dialogCustomLabels: false,
    dialogSetup: false,
    editable: {
      allow_multiple_plans: false,
      available_addons: [],
      available_countries: [],
      available_documents: [],
      available_plans: [],
      collection_scheme: 'send_invoice',
      custom_labels: [],
      instant: false,
      name: '',
      redirect_url: '',
      require_source: false,
      use_cache: true,
      webhook_url: ''
    },
    active: [],
    currentCurrency: null,
    selectDocuments: [],
    updateAddonDialog: 0,
    updateProductDialog: 0,
    step: 1
  }),
  computed: {
    ...mapState({
      documents: state => state.generals.documentsList,
      instance: state => state.apps.formsDetail
    }),
    activeCustomLabels () {
      return this.editable.custom_labels.filter(l => l.label)
    },
    allCountriesSelected () {
      return this.editable.available_countries.length === this.baseCountries.length
    },
    countriesSelectIcon () {
      if (this.allCountriesSelected) {
        return 'mdi-close-box'
      }
      if (this.someCountriesSelected) {
        return 'mdi-minus-box'
      }
      return 'mdi-checkbox-blank-outline'
    },
    countriesWithoutDocument () {
      const ac = this.editable.available_countries
      const ad = this.editable.available_documents.map(d => d.document)
      const countries = this.baseCountries.filter(c => ac.includes(c.id)).filter(c => !c.invoiceTypes.some(t => ad.includes(t)))
      return countries.map(({id, name}) => ({ id, name }))
    },
    hasCustomLabels () {
      return this.editable.custom_labels.some(l => l.label)
    },
    someCountriesSelected () {
      return this.editable.available_countries.length > 0 && !this.allCountriesSelected
    }
  },
  watch: {
    'editable.available_addons': {
      deep: true,
      handler: function (newValue) {
        if (newValue.length === 0) {
          this.updateAddonDialog += 1
        }
      }
    },
    'editable.available_plans': {
      deep: true,
      handler: function (newValue) {
        if (newValue.length === 0) {
          this.currentCurrency = null
          this.updateProductDialog += 1
        }
      }
    }
  },
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        is_sale: 'True'
      }
    })
    .then(() => {
      // generic documents
      const generics = this.documents.filter(d => d.country !== this.account.country.id)
      this.selectDocuments.push({ header: 'Genéricos' })
      this.selectDocuments = [...this.selectDocuments, ...generics]
      // local documents
      const sameCountry = this.documents.filter(d => d.country === this.account.country.id)
      if (sameCountry.length) {
        this.selectDocuments.push({ divider: true })
        this.selectDocuments.push({ header: this.account.country.name })
        this.selectDocuments = [...this.selectDocuments, ...sameCountry]
      }
    })
    this.$store.dispatch('apps/RETRIEVE', {
      resource: 'signup_forms/forms',
      id: this.$route.params.id
    })
    .then(() => {
      const clone = cloneDeep(this.instance)

      Object.keys(this.editable).forEach(k => {
        this.editable[k] = clone[k]
      })

      // enable all available custom labels
      Object.keys(this.customLabels).forEach(k => {
        if (!this.editable.custom_labels.find(l => l.field_name === k)) {
          this.editable.custom_labels.push({
            field_name: k,
            label: ''
          })
        }
      })
    })
  },
  methods: {
    availableDocumentAdd () {
      if (!this.availableDocumentSelected) {
        return false
      }
      const document = this.documents.find(d => d.id === this.availableDocumentSelected)
      const item = {
        document: document.id,
        currency: document.currencies.length === 1 ? document.currencies[0] : null
      }
      if (!this.availableDocumentIsAdded(document)) {
        this.editable.available_documents.push(item)
      }
    },
    availableDocumentCurrencies (id) {
      const document = this.documents.find(d => d.id === id)
      return this.currencies.filter(c => document.currencies.includes(c.id))
    },
    availableDocumentIsAdded (item) {
      return this.editable.available_documents.find(d => d.document === item.id)
    },
    availableDocumentName (id) {
      const document = this.documents.find(d => d.id === id)
      if (document) {
        return document.name
      }
      return ''
    },
    updateForm () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }

      const payload = Object.assign({}, this.editable)

      if (!payload.require_source && payload.collection_scheme === 'charge_payment') {
        payload.collection_scheme = 'send_invoice'
      }

      payload.available_plans = payload.available_plans.map(ap => {
        return {
          allow_quantity: ap.allow_quantity,
          custom_id: ap.custom_id,
          description: ap.description,
          min_quantity: ap.min_quantity,
          name: ap.name,
          plan: ap.plan.id
        }
      })

      payload.available_addons = payload.available_addons.map(aa => {
        return {
          addon: aa.addon.id,
          allow_quantity: aa.allow_quantity,
          description: aa.description,
          is_mandatory: aa.is_mandatory,
          min_quantity: aa.min_quantity,
          name: aa.name
        }
      })

      payload.custom_labels = payload.custom_labels.filter(l => l.label)

      this.$store.dispatch('apps/UPDATE', {
        resource: 'signup_forms/forms',
        id: this.$route.params.id,
        payload: payload
      })
      .then((response) => {
        this.$router.push({
          name: 'FormDetail',
          params: {
            id: response.data.id
          },
          query: {
            ref: 'setup'
          }
        })
        this.$dialog.message.info('Los cambios del formulario han sido guardados.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    toggleCountries () {
      this.$nextTick(() => {
        if (this.allCountriesSelected) {
          this.editable.available_countries = []
        } else {
          this.editable.available_countries = this.baseCountries.map(c => c.id)
        }
      })
    },
    toggleDocuments () {
      this.$nextTick(() => {
        if (this.allDocumentsSelected) {
          this.editable.available_documents = []
        } else {
          this.editable.available_documents = this.documentsList.slice()
        }
      })
    },
    updatePlan (active) {
      let updateAvailablePlans = []
      active.forEach(item => {
        this.editable.available_plans.find(p => {
          if (item.id === p.plan.id) {
            updateAvailablePlans.push(p)
          }
        })
      })
      this.editable.available_plans = updateAvailablePlans
    },
    setPlan (item) {
      this.editable.available_plans.push({
        allow_quantity: false,
        custom_id: null,
        description: item.description,
        min_quantity: 1,
        name: item.name,
        plan: item
      })
      this.currentCurrency = this.editable.available_plans[0].plan.currency.id
    },
    updateAddon (active) {
      const updateAvailableAddons = []
      active.forEach(item => {
        this.editable.available_addons.find(aa => {
          if (item.id === aa.addon.id) {
            updateAvailableAddons.push(aa)
          }
        })
      })
      this.editable.available_addons = updateAvailableAddons
    },
    setAddon (item) {
      this.editable.available_addons.push({
        addon: item,
        allow_quantity: false,
        description: item.description,
        is_mandatory: false,
        min_quantity: 1,
        name: item.name
      })
    },
    getCurrency () {
      return (((this.editable.available_plans || [])[0] || {}).plan || {}).currency || null
    }
  },
  validations: {
    editable: {
      available_addons: {
        $each: {
          description: {
            maxLength: maxLength(256)
          },
          min_quantity: {
            required,
            minValue: minValue(1)
          },
          name: {
            required,
            maxLength: maxLength(56)
          }
        }
      },
      available_countries: {
        required
      },
      available_documents: {
        required,
        $each: {
          document: {
            required
          },
          currency: {
            required
          }
        },
        countriesWithoutDocument: function () {
          return !this.countriesWithoutDocument.length
        }
      },
      available_plans: {
        required,
        $each: {
          custom_id: {
            maxLength: maxLength(24)
          },
          description: {
            maxLength: maxLength(256)
          },
          min_quantity: {
            required,
            minValue: minValue(1)
          },
          name: {
            required,
            maxLength: maxLength(56)
          }
        }
      },
      custom_labels: {
        $each: {
          label: {
            maxLength: maxLength(24)
          }
        }
      },
      name: {
        required,
        maxLength: maxLength(56)
      },
      webhook_url: {
        url,
        maxLength: maxLength(256)
      },
      redirect_url: {
        url,
        maxLength: maxLength(256)
      }
    }
  }
}
</script>
